import { ConversationAuditLogEntry } from 'apis/auditLogs';

import { getLogEntryAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

type ConversationTaggedProps = {
  entry: ConversationAuditLogEntry<'TAG_ADDED' | 'TAG_REMOVED'>;
};

export const ConversationTagged = ({
  entry,
}: ConversationTaggedProps): JSX.Element => {
  const actionType = entry.activity_type === 'TAG_ADDED' ? 'added' : 'removed';
  const preposition = entry.activity_type === 'TAG_ADDED' ? 'to' : 'from';

  const authorName = getLogEntryAuthorName(entry);
  const authorLink = <UserLink userId={entry.author.id}>{authorName}</UserLink>;

  const text = (
    <>
      The tag &quot;{entry.tag}&quot; was {actionType} {preposition} the
      conversation by {authorLink}
    </>
  );

  return <LogEntry entry={entry} text={text} />;
};
